module.exports = __webpack_public_path__ + "9dc1d2bddcde549379751ed9b00f4d4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./img/mobile/m-service-img3.jpg
// module id = 247
// module chunks = 2